import React, { useState } from 'react';
import { Button, Card, FlexRow, FormCell, Grid, Header2Text } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { LenderContactsTable } from './LenderContactsTable';
import { AddLenderContact } from './AddLenderContact';
import { EditLenderContact } from './EditLendersContact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons';
import { ILenderUserData } from '../../types/lenders/ILenderUser';
import { useListContactFunctionsQuery } from '../../API/contacts/ContactFunctionsApi';
import { Show } from '../shared/Show';

interface ILenderContactsBlockProps {
  lenderContacts: ILenderUserData[];
  onAddContact: (data: ILenderUserData) => void;
  onAddContactReset: () => void;
  addContactFetchStatus: IFetchStatus;
  getContactFetchStatus: IFetchStatus;
  addContactError?: Error;
  onEditContact: (data: ILenderUserData) => void;
  onEditContactReset: () => void;
  editContactFetchStatus: IFetchStatus;
  editContactError?: Error;
}

export const LenderContactsBlock: React.FC<ILenderContactsBlockProps> = ({
  lenderContacts,
  onAddContact,
  onAddContactReset,
  addContactFetchStatus,
  getContactFetchStatus,
  addContactError,
  onEditContact,
  onEditContactReset,
  editContactFetchStatus,
  editContactError,
}) => {
  const [showAddForm, setShowForm] = useState(false);
  const [editContact, setEditContact] = useState<ILenderUserData | null>(null);
  const { data: contactFunctions = [] } = useListContactFunctionsQuery();

  const onResetAddContact = () => {
    onAddContactReset();
    setShowForm(false);
  };
  const onResetEditContact = () => {
    onEditContactReset();
    setEditContact(null);
  };

  const onInputEmail = (email: string) => {
    const lender = lenderContacts.find((l) => l.email === email);
    if (lender) {
      setShowForm(false);
      setEditContact(lender);
    }
  };

  return (
    <>
      <Card>
        <Grid>
          <FlexRow justifyContent={'space-between'} width={100}>
            <FormCell hintText={'Points of contact for the client.'}>
              <Header2Text>Lender Contacts</Header2Text>
            </FormCell>
            <Button intent={'secondary'} onClick={() => setShowForm(true)}>
              <FontAwesomeIcon icon={faUserPlus} /> Add New Contact
            </Button>
          </FlexRow>
          <Show when={contactFunctions.length !== 0}>
            <LenderContactsTable
              data={lenderContacts}
              loading={getContactFetchStatus.fetching}
              onEditContact={setEditContact}
              contactFunctions={contactFunctions}
            />
          </Show>
        </Grid>
      </Card>

      {showAddForm && (
        <AddLenderContact
          onSubmit={onAddContact}
          addFetchStatus={addContactFetchStatus}
          addFetchError={addContactError}
          onCancel={onResetAddContact}
          onAddContact={onInputEmail}
        />
      )}
      {editContact && (
        <EditLenderContact
          onSubmit={onEditContact}
          editFetchStatus={editContactFetchStatus}
          editFetchError={editContactError}
          onCancel={onResetEditContact}
          initialData={editContact}
        />
      )}
    </>
  );
};
